import type Validator from '../../models/Validator';

const BooleanValidator: Validator = class {
  static isValid(value) {
    return value === true || value === false;
  }

  static getError() {
    return null;
  }
};

export default BooleanValidator;
